var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"type":"datetime-local","label":_vm.label,"data-cy":"tfDateTime","max":"9999-12-30T23:59"},model:{value:(_vm.dateTime),callback:function ($$v) {_vm.dateTime=$$v},expression:"dateTime"}})}
var staticRenderFns = []

export { render, staticRenderFns }